/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuctionManagementEditAuctionBidRequest } from '../models/AuctionManagementEditAuctionBidRequest';
import type { AuctionManagementEditAuctionBidResponseApiRespoonse } from '../models/AuctionManagementEditAuctionBidResponseApiRespoonse';
import type { AuctionManagementExportLivecarpItemRequest } from '../models/AuctionManagementExportLivecarpItemRequest';
import type { AuctionManagementExportLivecarpItemResponseApiRespoonse } from '../models/AuctionManagementExportLivecarpItemResponseApiRespoonse';
import type { AuctionManagementListAuctionMetaRequest } from '../models/AuctionManagementListAuctionMetaRequest';
import type { AuctionManagementListAuctionMetaResponseApiRespoonse } from '../models/AuctionManagementListAuctionMetaResponseApiRespoonse';
import type { AuctionManagementListAuctionRequest } from '../models/AuctionManagementListAuctionRequest';
import type { AuctionManagementListAuctionResponseApiRespoonse } from '../models/AuctionManagementListAuctionResponseApiRespoonse';
import type { AuctionManagementOutputLivecarpItemCsvRequest } from '../models/AuctionManagementOutputLivecarpItemCsvRequest';
import type { HttpFoundationStreamedResponseApiRespoonse } from '../models/HttpFoundationStreamedResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuctionManagementAuctionService {

    /**
     * Auction
     * @param requestBody
     * @returns AuctionManagementListAuctionResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAuction(
        requestBody: AuctionManagementListAuctionRequest,
    ): CancelablePromise<AuctionManagementListAuctionResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/auction',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Auction Meta
     * @param requestBody
     * @returns AuctionManagementListAuctionMetaResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAuctionMeta(
        requestBody: AuctionManagementListAuctionMetaRequest,
    ): CancelablePromise<AuctionManagementListAuctionMetaResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/auction/meta',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Auction Meta
     * @param requestBody
     * @returns AuctionManagementEditAuctionBidResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAuctionEditBid(
        requestBody: AuctionManagementEditAuctionBidRequest,
    ): CancelablePromise<AuctionManagementEditAuctionBidResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/auction/edit-bid',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get link csv
     * @param requestBody
     * @returns AuctionManagementExportLivecarpItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAuctionCsv(
        requestBody: AuctionManagementExportLivecarpItemRequest,
    ): CancelablePromise<AuctionManagementExportLivecarpItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/auction/csv',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * export csv
     * @param requestBody
     * @returns HttpFoundationStreamedResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAuctionCsv1(
        requestBody: AuctionManagementOutputLivecarpItemCsvRequest,
    ): CancelablePromise<HttpFoundationStreamedResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/auction/csv',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
